export default "__VITE_ASSET__CE4mJAs___"